import React from 'react';
import {
  Box,
  Typography,
  LinearProgress,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Paper,
  Avatar,
} from '@mui/material';
import {
  CheckCircle,
  AutorenewRounded,
  HourglassEmpty,
} from '@mui/icons-material';
import { Loader } from 'lucide-react';

const ProgressCat = ({jobStatus}) => {
    console.log('jobStatus', jobStatus);
    const stepDescriptions = [
      "Reading Spend file",
      "Reading taxonomy file", 
      "Fetching material description and L1, L2 & L3 categories",
      "Cleaning and normalizing the material descriptions",
      "Doing Similarity search & using GPT 4o to map descriptions to category",
      "Formatting the output report",
      "Sending the output file in email",
      "Process completed"
    ];
  
    const getStepStatus = (index) => {
      const jobStep = jobStatus?.find(step => step.index === index + 1);
      if (!jobStep) return 'pending';
      
      if (jobStep.completed) return 'completed';
      
      // Check if this is the current active step (first incomplete step)
      const activeStepIndex = jobStatus.findIndex(step => !step.completed);
      if (activeStepIndex === index) return 'active';
      
      return 'pending';
    };
  
    const steps = stepDescriptions.map((description, index) => {
      const status = getStepStatus(index);
      return {
        text: description,
        status: status,
        strikethrough: status === 'completed'
      };
    });
  
    const calculateProgress = () => {
      if (!jobStatus || jobStatus.length === 0) return 0;
      const completedSteps = jobStatus.filter(step => step.completed).length;
      return Math.round((completedSteps / jobStatus.length) * 100);
    };
  
    const getIcon = (status) => {
      switch (status) {
        case 'completed':
          return <CheckCircle sx={{ color: '#4caf50', width:'18px', height:'18px' }} />;
        case 'active':
          return <Loader style={{ color: '#AC2A6E', animation: 'spin 1s linear infinite' , width:'18px', height:'18px'}} />;
        default:
          return <Loader style={{ color: '#666', width:'18px', height:'18px'}} />;
      }
    };
  
    const progressValue = calculateProgress();
  
    return (
      <Box
        sx={{ 
          backgroundColor: '#FFFFFF0F', 
          color: 'white', 
          width:'500px',
          p: '24px', 
          border: '1px solid #FFFFFF1A',
          borderRadius: '16px'
        }}
      >
        {/* Header */}
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
          <Loader sx={{ mr: 2, color: 'white' }} />
          <Box>
            <Typography variant="h6" sx={{ fontWeight: 500 }}>
              Categorizing the data
            </Typography>
            <Typography variant="body2" sx={{ color: '#aaa' }}>
              Secondary supporting text
            </Typography>
          </Box>
        </Box>
  
        {/* Progress Bar */}
        <Box sx={{ mb: 3 }}>
          <LinearProgress
            variant="determinate"
            value={progressValue}
            sx={{
              height: 8,
              borderRadius: 4,
              backgroundColor: '#444',
              '& .MuiLinearProgress-bar': {
                backgroundColor: '#AC2A6E',
                borderRadius: 4,
              },
            }}
          />
          <Typography 
            variant="body2" 
            sx={{ 
              textAlign: 'right', 
              mt: 1, 
              color: 'white',
              fontWeight: 500 
            }}
          >
            {progressValue}%
          </Typography>
        </Box>
  
        {/* Steps List */}
        <List sx={{ p: 0 }}>
          {steps.map((step, index) => (
            <ListItem 
              key={index} 
              sx={{ 
                px: 0, 
                py: 1,
                ...(step.status === 'active' && {
                  backgroundColor: '#FFFFFF14',
                  borderRadius: 2,
                  mb: 1
                })
              }}
            >
              <ListItemIcon sx={{ minWidth: 40,p:1 }}>
                {getIcon(step.status)}
              </ListItemIcon>
              <ListItemText 
                primary={step.text}
                primaryTypographyProps={{
                  sx: {
                    color: step.status === 'completed' ? '#4caf50' : 
                           step.status === 'active' ? 'white' : '#aaa',
                    textDecoration: step.strikethrough ? 'line-through' : 'none',
                    fontSize: '0.95rem'
                  }
                }}
              />
            </ListItem>
          ))}
        </List>
  
        <style jsx>{`
          @keyframes spin {
            from { transform: rotate(0deg); }
            to { transform: rotate(360deg); }
          }
        `}</style>
      </Box>
    );
  };
  
  export default ProgressCat;